import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { resolveMediaUrl } from "@/lib/media";

const STATUS_LABEL = { idea: "Idea", en_desarrollo: "En desarrollo", lanzado: "Lanzado" };

export default function ProductDetailPage() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/products/${id}`).then(setP).catch(() => setP(null)); }, [id]);

  if (!p) return <div className="min-h-[60vh] flex items-center justify-center text-muted-foreground">Cargando...</div>;

  return (
    <div data-testid="product-detail-page" className="pt-12 pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Link to="/productos" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8">
          <ArrowLeft className="w-4 h-4" /> Volver a productos
        </Link>
        <div className="grid lg:grid-cols-12 gap-10">
          <motion.div initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }} className="lg:col-span-6">
            <div className="aspect-[4/3] rounded-sm overflow-hidden border border-border bg-secondary">
              {p.image && <img src={resolveMediaUrl(p.image)} alt={p.name} className="w-full h-full object-cover" />}
            </div>
          </motion.div>
          <div className="lg:col-span-6">
            <div className="flex items-center gap-2 mb-3">
              <span className="bg-primary/10 text-primary text-[10px] uppercase tracking-widest font-bold px-3 py-1 rounded-sm">{p.category}</span>
              <span className="text-[10px] uppercase tracking-widest font-bold px-3 py-1 rounded-sm border border-border">{STATUS_LABEL[p.status] || p.status}</span>
            </div>
            <h1 className="font-display text-5xl lg:text-7xl font-black tracking-tighter mb-3">{p.name}</h1>
            {p.talent_name && <p className="text-sm text-muted-foreground mb-6">Co-creado con <strong className="text-foreground">{p.talent_name}</strong></p>}
            <p className="text-base lg:text-lg leading-relaxed mb-6">{p.short_description}</p>
            {p.long_description && <p className="text-sm text-muted-foreground leading-relaxed mb-8 whitespace-pre-wrap">{p.long_description}</p>}
            <div className="flex flex-wrap gap-3">
              <Link to="/contacto" className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary text-primary-foreground font-semibold rounded-sm hover:opacity-90">
                {p.cta_label || "Quiero saber más"}
              </Link>
              {p.link && (
                <a href={p.link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-7 py-3.5 border border-border font-semibold rounded-sm hover:border-primary hover:text-primary transition-colors">
                  Ver más <ExternalLink className="w-4 h-4" />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
